import setupAxios from './setup-axios';

export default function BigdefItlAPI() {
  const axiosConfig = {
    baseURL: process.env.BIGDEF_ITL_API_URL
  };

  const axios = setupAxios(axiosConfig);

  const api = {
    dictionaryWordsWithWordList(parameters) {
      const { wordListId, q, fields } = parameters;

      const url = '/dictionary_words/with_word_list';

      const params = {
        q,
        word_list_id: wordListId,
        fields
      };

      return axios.get(url, { params })
        .then(({ data }) => data);
    },

    bulkLookups(sync, languageCode) {
      const params = { sync, language_code: languageCode };

      return axios.post('/bulk_lookups', params)
        .then(({ data }) => data);
    },

    dictionaryWordsWithCommonWordList(parameters) {
      const url = '/dictionary_words/with_common_word_list';

      return axios.get(url, { params: parameters })
        .then(({ data }) => data);
    },

    dictionaryWordsWithSuggestedWordList(parameters) {
      const url = '/dictionary_words/with_suggested_word_list';

      return axios.get(url, { params: parameters })
        .then(({ data }) => data);
    },

    dictionaryWordsWithMediaItem(parameters) {
      const { mediaItemId, isForUser, wordListId, q, fields } = parameters;

      const url = '/dictionary_words/with_mediaitem';

      const params = {
        q,
        mediaitem_id: mediaItemId,
        is_for_user: isForUser,
        word_list_id: wordListId,
        fields
      };

      return axios.get(url, { params })
        .then(({ data }) => data);
    }
  };

  return api;
}
